<template>
  <th
    v-if="header"
    :class="[
      sortIsDisabled ? '' : 'column sortable',
      pagination.descending ? 'desc' : 'asc',
      header.value === pagination.sortBy ? 'active' : ''
    ]"
    :style="{ width: header.width }"
    :id="header.text"
  >
    <v-layout row align-center :style="headerStyle">
      <span
        @click="!sortIsDisabled && changeSort(header.value)"
        :title="header.text"
        :style="[
          headerLabelStyle,
          {
            'max-width':
              header.hasFilter
                ? filterActive
                    ? !sortIsDisabled
                      ? 'calc(100% - 40px)'
                      : 'calc(100% - 28px)'
                    : !sortIsDisabled
                      ? 'calc(100% - 28px)'
                      : 'calc(100% - 12px)'
                : sortIsDisabled
                  ? '100%'
                  : 'calc(100% - 12px)'
          }
        ]"
      >
        {{ header.text }}
      </span>
      <v-icon v-if="!sortIsDisabled" small @click="changeSort(header.value)">
        {{ sortIcon }}
      </v-icon>

      <v-menu v-if="header.hasFilter" offset-y :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-icon size="12" style="opacity: 1; transform: unset" v-on.stop="on">
            more_vert
          </v-icon>
        </template>
        <v-card style="padding: 2px 10px">
          <slot />
        </v-card>
      </v-menu>

      <v-icon
        v-if="filterActive"
        size="12"
        style="opacity: 1; transform: unset"
        color="accent"
      >
        filter_alt
      </v-icon>
    </v-layout>
  </th>
</template>

<script>
export default {
  name: "FieldManagementActivityTableHeaderCell",

  props: {
    header: {
      type: Object,
      required: true
    },

    pagination: {
      type: Object,
      required: true
    },

    filterActive: {
      type: Boolean,
      required: false
    },

    sortIsDisabled: {
      type: Boolean,
      required: false
    },

    sortIcon: {
      type: String,
      default: "arrow_drop_down"
    },

    headerStyle: {
      type: String,
      default: '',
    },

    headerLabelStyle: {
      type: Object,
      default: () => ({ overflow: 'hidden' }),
    },
  },

  methods: {
    changeSort(column) {
      this.$emit("sort", column);
    },

    defaultHeaderLabelStyle() {
      return { overflow: 'hidden' }
    },
  },
};
</script>

<style>
/**
 * Visibility of sort icon
 */
.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th
  .sort-icon.v-icon {
  visibility: hidden;
}

/**
 * Visibility of sort icon
 */
.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:hover
  .sort-icon.v-icon {
  visibility: visible;
}

.theme--dark.v-icon:focus:after {
  opacity: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/FieldManagement/FieldWork/Data/ActivityListTableHeaderCell.vue